<template>
  <div class="table-common">
    <div class="header d-lg-flex d-none row">
      <div v-for="(col, i) in header" :key="i" :class="`col-${col.width}`">{{ col.name }}</div>
    </div>

    <div v-for="col in rows" :key="col.id" class="row">
      <slot name="body" :col="col"></slot>
    </div>
  </div>

</template>

<script>
export default {
  name: "TableElements",
  props: {
    rows: {
      type: Array
    },
    header: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.table-common {

  .row:not(.header) {
    border-bottom-color: var(--default-icon-color);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    padding: .6em 0;
    background: transparent;

    display: flex;
    align-items: center;
  }

  .row:last-child {
    border: none;
  }

  .header {
    color: var(--common-text);

    div:not(:first-child) {
      text-align: left;
    }
  }

}
</style>
